import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC, PropsWithChildren } from 'react';
// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/design-system-component-lib/dist/components/typography/types';

import { StyledDescription, StyledDescriptionProps } from './description.styled';

type Props = StyledDescriptionProps & PropsWithChildren<Omit<TypographyProps, 'variant' | 'maxBreakpoint'>>;

export const Description: FC<Props> = (props) => {
    const { children, ...rest } = props;

    return (
        <StyledDescription {...rest} variant="paragraph1" maxBreakpoint={Breakpoint.TABLET}>
            {children}
        </StyledDescription>
    );
};
